import { useState } from "react";

export function AnswerGrid({
  title = "Yes",
  icon_url = "",
  selected = false,
  onClick,
}) {
  return (
    <div
      className={
        selected
          ? "ags ag elementor-animation-shrink"
          : "agns ag elementor-animation-shrink"
      }
      onClick={onClick}
    >
      <div className="col1">
        {icon_url && <img src={icon_url} className="image_ag" alt="" />}
      </div>
      <div className="col2" style={{ textAlign: icon_url ? "left" : "center" }}>
        <label className="answer_grid">{title}</label>
      </div>

      <div className="col3">
        {selected ? (
          <i aria-hidden="true" class="far fa-check-circle"></i>
        ) : (
          <i aria-hidden="true" class="far fa-circle"></i>
        )}
      </div>
    </div>
  );
}

export function Submit({ headtitle, fills, submit_btn_title, handleForm }) {
  const [statusForm, setStatusForm] = useState({
    log: "",
    processing: false,
    sended: false,
  });
  return (
    <div className="flow">
      <label className="headtitle">{headtitle}</label>
      <form onSubmit={(e) => handleForm(e, setStatusForm)}>
        {fills.map((fill, i) => {
          return <input {...fill} className="input" key={i} required />;
        })}
        <label className="log-text">{statusForm.log}</label>
        {!statusForm.sended && !statusForm.processing && (
          <button
            type="submit"
            className="submitBtn elementor-animation-shrink"
          >
            {submit_btn_title}
          </button>
        )}
      </form>
    </div>
  );
}
